const firebaseConfig = {
  apiKey: "AIzaSyBpg1CQYXO__AhVnPmdh_XJgIRerMVEtL4",
  authDomain: "travelstargo.firebaseapp.com",
  projectId: "travelstargo",
  storageBucket: "travelstargo.appspot.com",
  messagingSenderId: "882337275188",
  appId: "1:882337275188:web:9f1695a6235c3c2eec1961"
};
export default firebaseConfig